'use client';
import { StateCreator } from 'zustand/index';
import { CalendarStore } from '@/hooks/use-calendar-store';

export type SearchStore = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  clearSearch: () => void;
};

export const createSearchSlice: StateCreator<Partial<CalendarStore> & SearchStore> = (set) => ({
  searchQuery: '',
  setSearchQuery: (query: string) => {
    set(() => ({
      searchQuery: query,
    }));
  },
  clearSearch: () => {
    set(() => ({
      searchQuery: '',
    }));
  },
});
